/**
 * 可控随机数生成器
 * 使用正弦函数实现可重复的伪随机序列
 */
export class Random {
    private seed: number;
    private initialSeed: number;

    constructor(seed: number = 1) {
        this.seed = seed;
        this.initialSeed = seed;
    }

    /**
     * 重置到初始种子
     */
    reset(): void {
        this.seed = this.initialSeed;
    }

    /**
     * 设置新种子
     */
    setSeed(seed: number): void {
        this.seed = seed;
        this.initialSeed = seed;
    }

    /**
     * 获取当前种子值
     */
    getSeed(): number {
        return this.initialSeed;
    }

    /**
     * 生成 [0, 1) 范围的随机数
     */
    next(): number {
        const x = Math.sin(this.seed) * 10000;
        this.seed += 1;
        return x - Math.floor(x);
    }

    /**
     * 生成 [min, max) 范围的随机数
     */
    uniform(min: number, max: number): number {
        return min + this.next() * (max - min);
    }

    /**
     * 生成随机布尔值
     */
    bool(): boolean {
        return this.next() > 0.5;
    }

    /**
     * 生成 [min, max] 范围的随机整数
     */
    int(min: number, max: number): number {
        return Math.floor(this.uniform(min, max + 1));
    }

    /**
     * 从数组中随机选择一个元素
     */
    pick<T>(array: T[]): T {
        return array[this.int(0, array.length - 1)];
    }

    /**
     * 打乱数组（Fisher-Yates 洗牌算法）
     */
    shuffle<T>(array: T[]): T[] {
        const result = [...array];
        for (let i = result.length - 1; i > 0; i--) {
            const j = this.int(0, i);
            [result[i], result[j]] = [result[j], result[i]];
        }
        return result;
    }
}

// 默认全局随机数生成器
export const globalRandom = new Random();
